import * as types from './actionTypes.scriptEditor';
import initialState from '../initialState';

const initialStateObj = {
    highlightedLine: null,
    highlightedLineType: null,
    searchPanels: {},
    totalSearchResults: 0,
    currentSearchItem: 0,
    lastOpen: Date.now(),
    lastSearchUpdate: Date.now(),
    ...initialState.editor
};

export default function ScriptEditorReducerReducer(state = initialStateObj, action) {
    switch (action.type) {

        case types.HIGHLIGHT_LINE_OK:
            return {
                ...state,
                ...{
                    highlightedLine: action.lineNumber,
                    highlightedLineType: action.lineType,
                    highlightedCharacter: action.character,
                    highlightedLineOffset: action.lineOffset,
                    highlightedDefinitionName: action.definitionName,
                }
            };

        case types.UNHIGHLIGHT_LINE_REQ:
            return {
                ...state,
                ...{
                    highlightedLine: null,
                    highlightedLineType: null,
                    highlightedCharacter: null,
                    highlightedLineOffset: null,
                    highlightedDefinitionName: null,
                }
            };

        case types.CHANGE_EDITOR_FONT_SIZE_OK:
            return {
                ...state,
                fontSize: action.fontSize
            };

        case types.CHANGE_EDITOR_THEME_OK:
            return {
                ...state,
                codeTheme: action.codeTheme
            };

        case types.SCRIPT_SEARCH_SHOW_OK:
            return {
                ...state,
                searchPanels: {
                    ...state.searchPanels,
                    [action.searchKey]: {
                        ...state.searchPanels[action.searchKey],
                        showSearch: action.showSearch,
                        showReplace: action.showReplace,
                        lastOpen: action.showSearch ? Date.now() : state.lastOpen,
                    }
                },
            };

        case types.SCRIPT_SEARCH_UPDATE_OK:
            return {
                ...state,
                searchPanels: {
                    ...state.searchPanels,
                    [action.searchKey]: {
                        ...state.searchPanels[action.searchKey],
                        lastSearchUpdate: action.lastSearchUpdate,
                    }
                },
            };

        case types.SCRIPT_SEARCH_RESET_OK:
            return {
                ...state,
                searchPanels: {},
                statsScriptsSearch: {},
            };

        case types.SCRIPT_SEARCH_SEARCH_TERM_OK:
            return {
                ...state,
                searchPanels: {
                    ...state.searchPanels,
                    [action.searchKey]: {
                        ...state.searchPanels[action.searchKey],
                        searchTerm: action.searchTerm,
                        statsScriptsSearch: action.statsScriptsSearch,
                    }
                },
            };

        case types.SCRIPT_SEARCH_REPLACE_TERM_OK:
            return {
                ...state,
                searchPanels: {
                    ...state.searchPanels,
                    [action.searchKey]: {
                        ...state.searchPanels[action.searchKey],
                        replaceTerm: action.replaceTerm,
                    }
                },
            };
        case types.SCRIPT_SEARCH_SET_META_OK:
            return {
                ...state,
                searchPanels: {
                    ...state.searchPanels,
                    [action.searchKey]: {
                        ...state.searchPanels[action.searchKey],
                        totalSearchResults: action.totalSearchResults,
                        currentSearchItem: action.currentSearchItem,
                    }
                },

            };

        default:
            return state;
    }
}
